import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import { buildObjectKey, courseMetadata } from './keys.js';

/**
 * lib-storage picks single-part or multipart by size on its own, and a
 * multipart upload survives a dropped part rather than failing the whole
 * transfer. That matters for a 45-minute lecture on a phone.
 */
export async function uploadMemo({ config, session, file, course, onProgress }) {
  const client = new S3Client({
    region: config.region,
    credentials: session.credentials,
  });

  const key = buildObjectKey(session.identityId, file.name, new Date());

  const upload = new Upload({
    client,
    params: {
      Bucket: config.memoBucket,
      Key: key,
      Body: file,
      ContentType: file.type || 'application/octet-stream',
      Metadata: courseMetadata(course),
    },
    queueSize: 3,
    partSize: 8 * 1024 * 1024,
    leavePartsOnError: false,
  });

  upload.on('httpUploadProgress', (p) => {
    if (p.total) onProgress(Math.round((p.loaded / p.total) * 100));
  });

  await upload.done();
  return key;
}

export function describeUploadError(err) {
  const name = err?.name ?? '';
  if (name === 'AccessDenied' || name === 'AccessDeniedException') {
    return 'S3 refused the upload. The signed-in account may not have permission.';
  }
  if (name === 'ExpiredToken' || name === 'ExpiredTokenException') {
    return 'Your session expired. Sign in again and retry.';
  }
  if (name === 'NetworkingError' || name === 'TimeoutError') {
    return 'The connection dropped during upload. Try again.';
  }
  return 'The upload failed. Try again.';
}
